import PlacesSearch from '@src/components/home/PlacesSearch';
import React, { useState } from 'react';
import Modal from 'react-responsive-modal';

import Model from './model';

function CollectionTitle({ label, locationRequired, geolocation, imageUrl, isUpdating, first_name, isAvailable }) {
	const [showAddressModal, setShowAddressModal] = useState(false);
	const formattedAddress = geolocation?.formattedAddress || geolocation?.formatted_address;
	return (
		<div>
			<PlacesSearch modalOnly isModalOpen={showAddressModal} />

			{!isUpdating ? (
				<>
					<h1 className="collection-title">
						{isAvailable ? 
							<span className="info success">
								<i className="fas fa-check-circle" aria-hidden="true"></i>
								{first_name ? `Hi, ${first_name}` : 'Products Available'}{' '}
							</span> :
							<span className="info error">
								{'Products'}{' '}
							</span>
						}
						<span className="info helper">{first_name ? ' items for ' : 'for your '}</span>

						<Model imageUrl={imageUrl ? imageUrl : ''} label={label} />

						<span> </span>
						{!locationRequired && (
							<span className="outlined location">
								<span className="font-weight-normal">Near </span>
								<span className="mr-2">
									{/*// replace(/,[^,]+$/, "") => Remove everything after last comma */}
									{formattedAddress?.replace(/,[^,]+$/, '')}
								</span>
								<button className="btn" onClick={() => setShowAddressModal(true)}>
									(Change)
								</button>
							</span>
						)}
					</h1>
					{locationRequired && (
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
							<div style={{ width: '300px' }}>
								<h6>Update Your Location - Required</h6>
							</div>
						</div>
					)}
				</>
			) : (
				<h1 className="collection-title">
					<span className="info success">
						<i className="fas fa-cog fa-spin" aria-hidden="true"></i> Loading Locations. Please Wait...
					</span>
				</h1>
			)}
		</div>
	);
}

export default CollectionTitle;
